import './ReactFeaturedCategoryList.scss'

import ReactFeaturedCategoryItem from './ReactFeaturedCategoryItem'
import { FCListBgVariations, ReactFeaturedCategoryListProps } from './types'
import ReactSectionHeader from '../../ReactSectionHeader'
import { CategoryItemType } from '../types'

const ReactFeaturedCategoryList = (props: ReactFeaturedCategoryListProps): JSX.Element => {
  const {
    heading,
    subheading,
    categoryitems = [],
    icon: categoryIcon,
    altIcon,
    listType,
    variation,
    id,
    isInEditor = false,
    tokenProperties = ''
  } = props

  let containsHeaders = false
  if (heading || subheading) {
    containsHeaders = true
  }

  return (
    <div
      id={id}
      data-testid={`react-featured-category-list-container`}
      className={`react-featured-category-list-container ${containsHeaders && 'contains-headers'} ${variation} ${
        variation === FCListBgVariations.BLUE_BACKGROUND ? 'padding-inside-container' : ''
      }`}
    >
      <ReactSectionHeader
        title={{ value: heading, isRTE: true }}
        description={{
          value: subheading,
          isRTE: true
        }}
        isInEditor={isInEditor}
      />
      <div className={`featured-category-list ${!containsHeaders && 'no-headers'}`}>
        {categoryitems &&
          categoryitems?.length > 0 &&
          categoryitems?.map((item: CategoryItemType, index: number) => {
            const { id, title, description, link, openinnewtab, icon: overrideIcon, iconAlt, anchor, useRte } = item
            const altIconText = overrideIcon ? iconAlt : altIcon
            const imgSrc = overrideIcon ? overrideIcon : categoryIcon
            return (
              <div
                id={id}
                className={'cards-container'}
                key={`react-category-list-item${index}}`}
                data-testid='react-category-list-item-card'
              >
                <ReactFeaturedCategoryItem
                  name={title}
                  description={description}
                  link={link}
                  target={openinnewtab}
                  altIconText={altIconText}
                  imgSrc={imgSrc}
                  variation={categoryitems?.length}
                  anchor={anchor}
                  listType={listType}
                  useRte={useRte}
                  tokenProperties={tokenProperties}
                />
              </div>
            )
          })}
      </div>
    </div>
  )
}
export default ReactFeaturedCategoryList
